module.exports = __webpack_public_path__ + "static/media/flower.d980fedd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/contact/flower.jpg
// module id = 324
// module chunks = 0